import { NewProductDataLayerData } from "~/constants/data-layer";
import { Nullable } from "~/types/general.types";
import { Logger } from "~/utils/logger";

const CATEGORY_DEPTH = 4;

const getCategoryInfo = (
  categoriesArray: unknown[],
  categoryIndex: number,
): string | undefined => {
  const categoryInfoEl = categoriesArray[categoryIndex];

  if (typeof categoryInfoEl !== "object" || categoryInfoEl === null) {
    return undefined;
  }

  const name = (categoryInfoEl as { name?: unknown }).name;

  return typeof name === "string" ? name : undefined;
};

const getCategoryKey = (
  index: number,
): keyof typeof NewProductDataLayerData | null => {
  switch (index) {
    case 0:
      return "itemCategory";
    case 1:
      return "itemCategory2";
    case 2:
      return "itemCategory3";
    case 3:
      return "itemCategory4";
    case 4:
      return "itemCategory5";
    default:
      return null;
  }
};

export const parseCategoryPathsDisplayableToGa = (
  fieldValue: Nullable<string> | undefined,
): {
  [NewProductDataLayerData.itemCategory]?: string;
  [NewProductDataLayerData.itemCategory2]?: string;
  [NewProductDataLayerData.itemCategory3]?: string;
  [NewProductDataLayerData.itemCategory4]?: string;
} => {
  const result: Partial<Record<NewProductDataLayerData, string>> = {};

  try {
    const fieldValueParsed = fieldValue && JSON.parse(fieldValue);

    if (!Array.isArray(fieldValueParsed)) {
      throw new Error("Parsed value is not an array");
    }

    const categoriesArray = fieldValueParsed[0];

    if (!Array.isArray(categoriesArray)) {
      throw new Error("Parsed value array does not contain the correct data");
    }

    for (let index = 0; index < CATEGORY_DEPTH; index++) {
      const categoryInfo = getCategoryInfo(categoriesArray, index);
      const key = getCategoryKey(index);
      if (categoryInfo && key) {
        const dataLayerKey = NewProductDataLayerData[key];
        result[dataLayerKey] = categoryInfo;
      }
    }
  } catch (e) {
    Logger.getLogger(parseCategoryPathsDisplayableToGa.name).debug(
      `Error during parsing categoryPathsDisplayable Bloomreach attribute: ${e}`,
    );
  }

  return result;
};
